// extracted by mini-css-extract-plugin
export default {"appLayout":"AppLayout_appLayout__KJFn8","mainContent":"AppLayout_mainContent__XIefU","contentWrapper":"AppLayout_contentWrapper__-hasb"};